import React from "react";
import "../styles/Credits.css";
import FadeInSection from "./FadeIn";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";

class Credits extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    return (
      <FadeInSection>
        <div id="credits">
          <div className="ending-credits">
            <div className="credit-name">© Cristian Sanchez Lopez</div>
            <a href="mailto:cristian4402@gmail.com">
            <EmailRoundedIcon style={{ fontSize: 21 }}></EmailRoundedIcon>
            </a>
            <a href="https://github.com/Cxlopez">
              <GitHubIcon style={{ fontSize: 18 }}></GitHubIcon>
            </a>
            <a href="http://linkedin.com/in/cristian-sanchez-lopez">
              <LinkedInIcon style={{ fontSize: 21 }}></LinkedInIcon>
            </a>
          </div>
        </div>
      </FadeInSection>
    );
  }
}

export default Credits;